var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4186_20188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95801 2.16406H2.16634C1.87902 2.16406 1.60347 2.2782 1.40031 2.48136C1.19714 2.68453 1.08301 2.96008 1.08301 3.2474V10.8307C1.08301 11.118 1.19714 11.3936 1.40031 11.5968C1.60347 11.7999 1.87902 11.9141 2.16634 11.9141H9.74967C10.037 11.9141 10.3125 11.7999 10.5157 11.5968C10.7189 11.3936 10.833 11.118 10.833 10.8307V7.03906",
    stroke: "#005BF0",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0205 1.35217C10.236 1.13669 10.5283 1.01562 10.833 1.01562C11.1378 1.01563 11.43 1.13669 11.6455 1.35217C11.861 1.56766 11.9821 1.85993 11.9821 2.16467C11.9821 2.46942 11.861 2.76169 11.6455 2.97717L6.49967 8.12301L4.33301 8.66467L4.87467 6.49801L10.0205 1.35217Z",
    stroke: "#005BF0",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4186_20188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.d5e23e1ff86dc3b7d442713d16491395.svg";
export { ForwardRef as ReactComponent };